export default __webpack_public_path__ + "static/media/houston.2510cc8d.jpg";